import { AnyAction, createSlice, Reducer, Slice } from '@reduxjs/toolkit';

import { VehiclePopulationStateModel } from './models/vehicle-population-state.model';
import { VehiclePopulationReducers } from './types/vehicle-population-reducers.type';

const initialState: VehiclePopulationStateModel = {
  data: null,
};

export const campaignVehiclePopulationSlice: Slice<
  VehiclePopulationStateModel,
  VehiclePopulationReducers,
  string
> = createSlice({
  name: 'vehiclePopulation',
  initialState,
  reducers: {
    setVehiclePopulation(state, action) {
      state.data = action.payload;
    },
    resetVehiclePopulation(state) {
      Object.assign(state, initialState);
    },
  },
});

export const { setVehiclePopulation, resetVehiclePopulation } =
  campaignVehiclePopulationSlice.actions;

const campaignVehiclePopulationSliceReducers: Reducer<
  VehiclePopulationStateModel,
  AnyAction
> = campaignVehiclePopulationSlice.reducer;

export default campaignVehiclePopulationSliceReducers;
